import type { IssueReportSource } from '@/lib/api/issue-reports';

/**
 * 문제 신고에 자동으로 붙는 진단 정보 — **allowlist 만**.
 *
 * 종전에는 최근 console log 50건을 그대로 실었다. 신청서 작성 화면의 로그에는 문서
 * 식별자·사용자 입력·토큰이 섞일 수 있어 어떤 경로에서도 본문을 보내지 않는다.
 * 서버(`IssueDiagnosticSanitizer`)가 같은 allowlist 로 한 번 더 거른다 — 정본은 서버다.
 * 계획: docs/plans/2026-08-24/guest-apply-임시계정-문제신고-연결-계획.md §7.1
 */
export interface SafeIssueDiagnostic {
  timestamp: string;
  sourceType: IssueReportSource;
  browserInfo: string;
  language: string;
  platform: string;
  viewport: string;
  errorCode?: string;
  httpStatus?: number;
  /** 도움말을 보다 신고했으면 그 문서 id. 신고 주소만으로는 어느 문서였는지 남지 않는다(점검 N-S17). */
  helpDocId?: string;
}

export function buildSafeIssueDiagnostic(
  sourceType: IssueReportSource,
  lastError?: { code?: string; httpStatus?: number } | null,
  helpDocId?: string,
): SafeIssueDiagnostic {
  const diagnostic: SafeIssueDiagnostic = {
    timestamp: new Date().toISOString(),
    sourceType,
    browserInfo: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    language: typeof navigator !== 'undefined' ? navigator.language : '',
    platform: typeof navigator !== 'undefined' ? navigator.platform : '',
    viewport: typeof window !== 'undefined' ? `${window.innerWidth}x${window.innerHeight}` : '',
  };
  if (lastError?.code) diagnostic.errorCode = lastError.code;
  if (typeof lastError?.httpStatus === 'number') diagnostic.httpStatus = lastError.httpStatus;
  if (helpDocId) diagnostic.helpDocId = helpDocId;
  return diagnostic;
}
